import React from 'react';
import Vision from '../components/about/Vision';
import History from '../components/about/History';
import Leadership from '../components/about/Leadership';
import Services from '../components/about/Services';
import Accreditations from '../components/about/Accreditations';
import Partners from '../components/about/Partners';
import Stats from '../components/Stats';
import WhyChooseLSEM from '../components/WhyChooseLSEM';
import EnquiryForm from '../components/EnquiryForm';
import { Link } from 'react-router-dom';
import { ArrowRight, GraduationCap, Globe2, Award } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <section className="relative overflow-hidden bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 pt-32 pb-24">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=2070&auto=format&fit=crop"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-transparent" />
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-indigo-500/20 rounded-full blur-3xl" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-blue-500/10 border border-blue-400/30 text-blue-200 text-sm font-medium mb-6">
              <GraduationCap className="w-4 h-4 mr-2" />
              About LSEM
            </span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-tight">
              Shaping the Future of{' '}
              <span className="bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent">
                Global Trade
              </span>{' '}
              in Africa
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-slate-300 max-w-2xl">
              Since 2010, Lagos School of Export Management has trained thousands of
              professionals, entrepreneurs, and organizations to compete and win in
              international markets.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Link
                to="/courses"
                className="inline-flex items-center justify-center px-6 py-3 rounded-md bg-blue-600 hover:bg-blue-500 text-white font-medium transition-colors"
              >
                Explore Our Programs
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-6 py-3 rounded-md border-2 border-white/30 text-white hover:bg-white/10 font-medium transition-colors"
              >
                Speak to an Advisor
              </Link>
            </div>
          </div>

          {/* Quick badges */}
          <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-4xl">
            {[
              { icon: GraduationCap, label: '4,000+ Alumni', sub: 'Across 20+ countries' },
              { icon: Globe2, label: '15+ Years', sub: 'Of proven excellence' },
              { icon: Award, label: 'Fully Accredited', sub: 'NEPC & ITC certified' },
            ].map((b) => (
              <div
                key={b.label}
                className="flex items-center gap-4 rounded-xl bg-white/5 backdrop-blur border border-white/10 p-4"
              >
                <div className="w-11 h-11 rounded-lg bg-blue-500/20 flex items-center justify-center flex-shrink-0">
                  <b.icon className="h-5 w-5 text-blue-300" />
                </div>
                <div>
                  <div className="text-white font-semibold">{b.label}</div>
                  <div className="text-slate-400 text-sm">{b.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Vision />
      <History />
      <Services />
      <Stats />
      <Leadership />
      <WhyChooseLSEM />
      <Accreditations />
      <Partners />
      <EnquiryForm />
    </div>
  );
};

export default About;